// eslint-disable-next-line no-unused-vars
import React from "react";
import { Space } from "antd";

const Footer = () => {
  return (
    <div className="min-h-[42px] w-full bg-white flex items-center justify-center px-3 shadow-sm">
      <Space>
        Powered by <span className="font-bold">Ethereum</span>
      </Space>

    </div>
  );
};

export default Footer;
